const actions = {
  reset({ commit }) {},
  getCustomerAddresses({ rootState }) {
    return rootState.orders.address.addresses;
  },
  addAddresses({ rootState }, address) {
    rootState.orders.address.addresses.push(address);
  },
};

export default {
  namespaced: true,
  actions,
};
